// Externe Bibliotheken
import React, { Component, Fragment, memo } from 'react';
import { Link } from 'react-router';
import { Scrollbar } from 'smooth-scrollbar-react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import _ from 'lodash';

// Interne Module
import getDurationDays, {
    getHoursAndMinutes,
    getFlightStops,
    getLuggageDetails,
    getShortWeekday,
    getTravellers,
    mapRooms,
} from '@/_helper/bookingDetailsHelper';
import { AppContext } from '@/context/AppContext';
import * as storage from '@/_helper/storage';

// Komponenten
import OverlayModal from '@/comp/overlayModal/overlayModal';
import { Map } from '@/comp/map/Map';
import TransferDetails from './comp/transferDetails';
import ExcursionItem from './comp/excursionItem';
import HeroTeaser from '@/comp/heroTeaser';

// Styles
import './index.scss';

class BookingDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bookingData: props.bookingData,
        };

        this.getInsuranceData = this.getInsuranceData.bind(this);
        this.getTransferData = this.getTransferData.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    static contextType = AppContext;

    componentDidMount() {
        document.title = 'Buchungsdetails ' + window.$documentTitle;

        this.getInsuranceData();
        this.getTransferData();

        let $this = this;
        window.addEventListener('storage', (event) => {
            switch (event.key) {
                case 'newData':
                    let bookingData = storage.get('bookingData');
                    $this.setState({
                        bookingData: bookingData,
                    });
                    break;
                default:
            }
        });
    }

    hotelDetails(h) {
        return h.map((item, index) => {
            let stars = item.category !== undefined ? item.category : 0;

            let starContainer = [];
            for (let i = 0; i < parseInt(stars); i++) {
                starContainer.push(
                    <i key={`${index}-star-${i}`} className="material-symbols-outlined">
                        star
                    </i>
                );
            }

            const address = (
                <div>
                    {item.address1}
                    {item.address2 !== undefined && ', ' + item.address2}
                    {item.address3 !== undefined && ', ' + item.address3}
                    {item.countryDescription !== undefined && ', ' + item.address4}
                </div>
            );

            return (
                <div key={`hotelDetails-${index}`}>
                    {item.name !== undefined && <div className="name">{item.name}</div>}

                    {item.category !== undefined && <div className="stars">{starContainer}</div>}

                    {item.address1 !== undefined && (
                        <div className="item address">
                            <i className="material-symbols-outlined">location_on</i>
                            <div>
                                {address}
                                {this.props.bookingState === 'OK' && (
                                    <div
                                        className="button-element button-ghost"
                                        onClick={() => {
                                            this.toggleModal('accommodationMap');
                                        }}>
                                        Auf Karte ansehen
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {this.props.bookingState === 'OK' && this.state.accommodationMapModal && (
                        <OverlayModal
                            name="accommodation-map"
                            displayName="Kartenansicht"
                            scrollable={false}
                            toggleModal={() => {
                                this.toggleModal('accommodationMap');
                            }}>
                            <Map location={item} />
                        </OverlayModal>
                    )}

                    {item.checkIn !== undefined && item.checkOut !== undefined && (
                        <div className="item checkInOut">
                            <i className="material-symbols-outlined">bed</i>
                            <div>
                                <div>
                                    {`${getDurationDays(item.checkIn, item.checkOut)} Nächte vom ${item.checkIn} bis ${
                                        item.checkOut
                                    } `}
                                    <br />
                                    {item.rooms &&
                                        item.rooms.map((room, index) => {
                                            if (room?.room && room?.meal) {
                                                return (
                                                    <div key={`room-${index}`}>
                                                        {room?.room} &middot; {room?.meal}
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })}
                                </div>
                                {this.props.bookingState === 'OK' && (
                                    <div
                                        className="button-element button-ghost"
                                        onClick={() => {
                                            this.toggleModal('accommodationDetails');
                                        }}>
                                        Details zur Unterkunft anzeigen
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {this.props.bookingState === 'OK' && (
                        <>
                            {this.state.accommodationDetailsModal && (
                                <OverlayModal
                                    name="accommodation-details"
                                    displayName="Details zur Unterkunft"
                                    scrollable={false}
                                    toggleModal={() => {
                                        this.toggleModal('accommodationDetails');
                                    }}>
                                    <div className="left image-sec">
                                        <LazyLoadImage
                                            wrapperClassName="lazy-load-background"
                                            src={item.mainImage}
                                            alt={'Bild der Unterkunft'}
                                            effect="blur"
                                        />
                                    </div>
                                    <div className="right">
                                        {item.name !== undefined && <div className="name">{item.name}</div>}

                                        {item.category !== undefined && <div className="stars">{starContainer}</div>}

                                        <hr />

                                        <h5>Adresse der Unterkunft</h5>
                                        {item.address1 !== undefined && (
                                            <div className="item address">
                                                <i className="material-symbols-outlined">location_on</i>
                                                {address}
                                            </div>
                                        )}

                                        <hr />

                                        <Scrollbar>
                                            <div className="hotel-text">
                                                <h5>Hotelbeschreibung</h5>
                                                <div>{item.description}</div>
                                            </div>
                                        </Scrollbar>
                                    </div>
                                </OverlayModal>
                            )}
                        </>
                    )}
                </div>
            );
        });
    }

    cruiseDetails(cruise) {
        const { itinerary, persons, room: { details: rooms = [] } = {} } = cruise;

        const tabs = {
            booking: 'Ihre Buchung',
            itinerary: 'Reiseroute',
            'check-in': 'Check-In',
        };

        const modal = (currentTab) => (
            <OverlayModal
                name={`cruise-details ${currentTab}`}
                displayName={window.$browserInfo.device !== 'mobile' ? 'Details zur Kreuzfahrt' : tabs[currentTab]}
                scrollable={false}
                tabs={tabs}
                currentTab={currentTab}
                setTabName={(name) => this.setState({ cruiseDetailsModal: name })}
                toggleModal={() => this.toggleModal('cruiseDetails')}>
                {currentTab === 'booking'
                    ? bookingTab(cruise)
                    : currentTab === 'itinerary'
                      ? itineraryTab(itinerary)
                      : currentTab === 'check-in'
                        ? checkInTab(cruise)
                        : null}
            </OverlayModal>
        );

        const bookingTab = (cruise) => {
            const cabinProperties = [
                { name: 'meal', displayName: 'Verpflegung', values: [] },
                { name: 'name', displayName: 'Kabinenname', values: [] },
                { name: 'type', displayName: 'Kabinentyp', values: [] },
                { name: 'cabinNumber', displayName: 'Kabinennummer', values: [] },
            ];
            cabinProperties.forEach((item) => {
                rooms?.forEach((room) => {
                    if (room && room[item.name] && !item.values.includes(room[item.name])) {
                        item.values.push(room[item.name]);
                    }
                });
            });

            return (
                <>
                    <div className="left">
                        {cruise.shipName && (
                            <h4>
                                <i className="material-symbols-outlined">directions_boat</i>
                                {cruise.shipName}
                            </h4>
                        )}
                        <HeroTeaser state="customerarea" effect="blur" bookingState={window.$bookingState} />
                        <article>
                            <h4>
                                <i className="material-symbols-outlined">info</i>
                                CheckIn für Ihre Kreuzfahrt
                            </h4>
                            <p>
                                Alle wichtigen Informationen für den Check-In zu Ihrer Kreuzfahrt finden Sie{' '}
                                <a onClick={() => this.setState({ cruiseDetailsModal: 'check-in' })}>hier</a>.
                            </p>
                            <p>
                                Die genaue Einschiffungszeit entnehmen Sie bitte den Daten, die Sie von der Reederei
                                erhalten haben.
                            </p>
                        </article>
                    </div>
                    <div className="right">
                        <h4>
                            <i className="material-symbols-outlined">workspaces</i>
                            Details
                        </h4>
                        {cruise.shipName && (
                            <div className="details-item">
                                <h5>Name des Schiffs:</h5>
                                <p>{cruise.shipName}</p>
                            </div>
                        )}
                        {cruise.providerName && (
                            <div className="details-item">
                                <h5>Reedereiname:</h5>
                                <p>{cruise.providerName}</p>
                            </div>
                        )}
                        {cruise.itinerary.name && (
                            <div className="details-item">
                                <h5>Reisebezeichnung:</h5>
                                <p>{cruise.itinerary.name}</p>
                            </div>
                        )}
                        {cruise.supplierBookingNumber && (
                            <div className="details-item">
                                <h5>Buchungsnummer Reederei:</h5>
                                <p>{cruise.supplierBookingNumber}</p>
                            </div>
                        )}
                        {cruise.checkIn && cruise.checkOut && (
                            <div className="details-item">
                                <h5>Reisedauer:</h5>
                                <p>
                                    {cruise.checkIn} - {cruise.checkOut}, Anzahl Nächte:{' '}
                                    {getDurationDays(cruise.checkIn, cruise.checkOut)}
                                </p>
                            </div>
                        )}
                        {cabinProperties.map((item, index) => {
                            return (
                                item.values?.length > 0 && (
                                    <div className="details-item" key={index}>
                                        <h5>{item.displayName}:</h5>
                                        {item.values.map((room) => {
                                            return <p key={index}>{room}</p>;
                                        })}
                                    </div>
                                )
                            );
                        })}
                    </div>
                </>
            );
        };

        const itineraryTab = ({ name, image, detailedItinerary }) => (
            <>
                <div className="left">
                    <h4>
                        <i className="material-symbols-outlined">location_on</i>
                        Reiseroute des Schiffes
                    </h4>
                    <figure>
                        <LazyLoadImage wrapperClassName="lazy-load-background" src={image} alt={name} effect="blur" />
                        <figcaption>
                            Bildlegende: Die Reihenfolge der Häfen ist numerisch markiert. Der Starthafen ist rot
                            markiert. Alle Angaben sind ohne Gewähr. Es kann zu jeder Zeit zu möglichen Änderungen des
                            Zeitplans und der Reiseroute kommen.
                        </figcaption>
                    </figure>
                </div>
                <div className="right">
                    <h4>
                        <i className="material-symbols-outlined">calendar_month</i>
                        Ablaufplan nach Häfen und Tagen
                    </h4>
                    <div className="itinerary-schedule">
                        {detailedItinerary.map((item, index) => {
                            const port = ({ atSea, portCityName, portCountryName }) => {
                                if (atSea === 1) return 'Seetag';
                                if (portCityName && !portCountryName) return portCityName;
                                if (!portCityName && portCountryName) return portCountryName;
                                if (portCityName && portCountryName) return `${portCityName}, ${portCountryName}`;
                                return '';
                            };

                            return (
                                <div className="schedule-item" key={index}>
                                    <div className="item-day first-row">Tag&nbsp;{item.day}</div>
                                    <div className="item-bar">
                                        <span className="dot"></span>
                                    </div>
                                    <div className="item-location first-row">
                                        {item.date}&nbsp;&middot;&nbsp;{port(item)}
                                    </div>
                                    <div className="item-departure-arrival">
                                        <div>Ankunft: {item.arrival.time ?? '-'}</div>
                                        <div>Abfahrt: {item.departure.time ?? '-'}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </>
        );

        const checkInTab = ({ supplierBookingProviderCode, oci }) => {
            return (
                <>
                    <h4>
                        <i className="material-symbols-outlined">info</i>
                        Wichtige Informationen zum Check-In für Ihre Kreuzfahrt
                    </h4>
                    <div className="info-card">
                        <i className="material-symbols-outlined">lightbulb</i>
                        Auf der Webseite der Reederei müssen Sie sich registrieren, um das Schiffsmanifest auszufüllen.
                        Dort können Sie viele weitere Informationen z.B. zu den Themen Check-In, Gepäck, Kofferanhänger
                        etc. abrufen oder Sie erhalten diese per E-Mail.
                    </div>
                    {supplierBookingProviderCode && (
                        <>
                            <article className="check-in-code">
                                <h5>Buchungscode Reederei</h5>
                                <div className="article-content">
                                    <span>{supplierBookingProviderCode}</span>
                                    <p>
                                        Bitte benutzen Sie den Buchungscode der Reederei, um sich auf der Webseite der
                                        Reederei einzuloggen.
                                    </p>
                                    <p>
                                        Hinweis: Der Buchungscode der Reederei ist nicht identisch mit Ihrer AurumTours
                                        Buchungsnummer.
                                    </p>
                                </div>
                            </article>
                        </>
                    )}
                    {oci?.earliestPossibleOciDate && oci?.latestPossibleOciDate && (
                        <>
                            <article className="check-in-dates">
                                <h5>Online Check-In</h5>
                                <div className="article-content">
                                    <p>
                                        Online Check in möglich{' '}
                                        <span className="text-bold">ab {oci?.earliestPossibleOciDate}</span>
                                    </p>
                                    <p>
                                        Online Check in möglich{' '}
                                        <span className="text-bold">bis {oci?.latestPossibleOciDate}</span>
                                    </p>
                                    {oci.portalLink && (
                                        <>
                                            <p>
                                                Um den Check-In zu Ihrer Kreuzfahrt durchzuführen, öffnen Sie bitte
                                                folgenden Link:
                                                <a rel="noopener noreferrer" href={oci.portalLink} target="_blank">
                                                    {oci.portalLink}
                                                </a>
                                            </p>
                                        </>
                                    )}
                                </div>
                            </article>
                        </>
                    )}
                    {oci?.commentsOnCheckin && (
                        <>
                            <article>
                                <h5>Hinweise zum Check-In</h5>
                                <div className="article-content">
                                    <p>{oci.commentsOnCheckin}</p>
                                    {oci.commentsOnCheckInLink && (
                                        <a rel="noopener noreferrer" href={oci.commentsOnCheckInLink} target="_blank">
                                            {oci.commentsOnCheckInLink}
                                        </a>
                                    )}
                                </div>
                            </article>
                        </>
                    )}
                    {oci?.mandatoryDocuments && (
                        <>
                            <article>
                                <h5>Wichtige Dokumente</h5>
                                <div className="article-content">
                                    <p>{oci.mandatoryDocuments}</p>
                                    {oci.mandatoryDocumentsLink && (
                                        <a rel="noopener noreferrer" href={oci.mandatoryDocumentsLink} target="_blank">
                                            {oci.mandatoryDocumentsLink}
                                        </a>
                                    )}
                                </div>
                            </article>
                        </>
                    )}
                    {oci?.commentsOnLuggage && (
                        <>
                            <article>
                                <h5>Gepäckinformationen</h5>
                                <div className="article-content">
                                    <p>{oci.commentsOnLuggage}</p>
                                    {oci.commentsOnLuggageLink && (
                                        <a rel="noopener noreferrer" href={oci.commentsOnLuggageLink} target="_blank">
                                            {oci.commentsOnLuggageLink}
                                        </a>
                                    )}
                                </div>
                            </article>
                        </>
                    )}
                </>
            );
        };

        const amountAdults = persons?.amount?.adults;
        const amountChildren = persons?.amount?.children + persons?.amount?.infants;

        return (
            <>
                <div className="name">
                    {itinerary.name && cruise.providerName ? (
                        <>
                            Kreuzfahrt "{itinerary.name}" mit {cruise.providerName}
                        </>
                    ) : (
                        <>Ihre Kreuzfahrt</>
                    )}
                </div>
                <div className="item">
                    <i className="material-symbols-outlined">directions_boat</i>
                    <div>
                        {cruise.shipName && <p>Schiff: {cruise.shipName}</p>}
                        {cruise.checkIn && cruise.checkOut && (
                            <p>
                                {getDurationDays(cruise.checkIn, cruise.checkOut)} Nächte vom {cruise.checkIn} bis{' '}
                                {cruise.checkOut}
                            </p>
                        )}
                        {rooms &&
                            mapRooms(rooms).map((room, index) => {
                                if (room) {
                                    return (
                                        <p key={index}>
                                            {room?.count > 1 ? `${room?.count} ` : ''}
                                            {room?.name}&nbsp;&middot;&nbsp;{room?.meal}
                                        </p>
                                    );
                                }
                                return null;
                            })}
                        {amountAdults > 0 && (
                            <p>
                                {`${amountAdults} ${amountAdults > 1 ? 'Erwachsene' : 'Erwachsener'} `}
                                {amountChildren > 0 &&
                                    ` und ${amountChildren} ${amountChildren > 1 ? 'Kinder' : 'Kind'}`}
                            </p>
                        )}
                        {this.props.bookingState === 'OK' && (
                            <div className="button-container">
                                {Object.entries(tabs).map(([key, value]) => {
                                    return (
                                        <div
                                            className="button-element button-ghost"
                                            onClick={() => {
                                                this.toggleModal('cruiseDetails', key);
                                            }}
                                            key={key}>
                                            {value}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                        {this.state.cruiseDetailsModal && modal(this.state.cruiseDetailsModal)}
                    </div>
                </div>
            </>
        );
    }

    transferDetails(t) {
        return <TransferDetails bookingData={this.state.bookingData} bookingState={this.props.bookingState} />;
    }

    toggleModal(modal, tab = undefined) {
        switch (modal) {
            case 'flightDetails':
                this.setState({
                    flightDetailsModal: !this.state.flightDetailsModal,
                });
                break;
            case 'accommodationDetails':
                this.setState({
                    accommodationDetailsModal: !this.state.accommodationDetailsModal,
                });
                break;
            case 'accommodationMap':
                this.setState({
                    accommodationMapModal: !this.state.accommodationMapModal,
                });
                break;
            case 'cruiseDetails':
                this.setState({
                    cruiseDetailsModal: !this.state.cruiseDetailsModal && tab ? tab : false,
                });
                break;
            case 'seatReservation':
                this.setState({
                    seatReservationModal: !this.state.seatReservationModal,
                });
                break;
            case 'excursionDetails':
                this.setState({
                    excursionDetailsModal: !this.state.excursionDetailsModal,
                });
                break;
            case 'travellerDetails':
                this.setState({
                    travellerDetailsModal: !this.state.travellerDetailsModal,
                });
                break;
            default:
        }
    }

    flightDetails(f) {
        if (f?.inbound !== undefined || f?.outbound !== undefined) {
            return (
                <>
                    {Object.entries(f).map((value, index) => {
                        if (value !== undefined) {
                            const direction = value[0];
                            const legs = value[1];
                            const stops = legs?.length > 1 ? legs?.length - 1 : 0;

                            return (
                                <div className={`item ${direction}`} key={index}>
                                    <i className="material-symbols-outlined flight-icon">flight</i>
                                    <div>
                                        <div>
                                            <div>
                                                {`${getShortWeekday(legs[0].depDate)}., ${legs[0].depDate}`} &middot;{' '}
                                                {`${legs[0].depTime} - ${legs[stops].arrTime}`}
                                            </div>
                                            <div className="text-light">
                                                {`ab ${legs[0].depAirportDescription} (${legs[0].depAirportCode})`}{' '}
                                                &middot; {getFlightStops(f, direction)}
                                            </div>
                                        </div>
                                        {this.props.bookingState === 'OK' && index === Object.keys(f).length - 1 && (
                                            <div
                                                className="button-element button-ghost"
                                                onClick={() => {
                                                    this.toggleModal('flightDetails');
                                                }}>
                                                Flug- und Gepäckdetails anzeigen
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        } else {
                            return <></>;
                        }
                    })}

                    {this.props.bookingState === 'OK' && this.state.flightDetailsModal && (
                        <OverlayModal
                            name="flight-luggage-details"
                            displayName="Flug- und Gepäckdetails"
                            scrollable={false}
                            toggleModal={() => {
                                this.toggleModal('flightDetails');
                            }}>
                            <Scrollbar>
                                <div className="left">{this.flightExpandedDetails(f)}</div>
                            </Scrollbar>
                            <div className="right">
                                {this.state.bookingData.data.frontendParams?.travellers && (
                                    <div className="travellers detail-item">
                                        <i className="material-symbols-outlined">how_to_reg</i>
                                        <div className="cnt">
                                            <h4>Reisende</h4>
                                            {getTravellers(this.state.bookingData.data.frontendParams)}
                                        </div>
                                    </div>
                                )}
                                {this.state.bookingData.data.frontendParams?.luggage && (
                                    <div className="luggage detail-item">
                                        <i className="material-symbols-outlined">luggage</i>
                                        <div>
                                            <h4>Gepäckstücke</h4>
                                            {getLuggageDetails(this.state.bookingData.data.frontendParams)}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </OverlayModal>
                    )}
                </>
            );
        }
    }

    flightExpandedDetails(f) {
        /* FLIGHT */

        return (
            <>
                {f.outbound !== undefined && (
                    <div className="outbound detail-item">
                        <i className="material-symbols-outlined flight-icon">flight</i>
                        <div>
                            <h4>
                                Hinflug: {getShortWeekday(f.outbound[0].depDate)}., {f.outbound[0].depDate} &middot;{' '}
                                {getFlightStops(f, 'outbound')}
                            </h4>

                            {f.outbound.map((value, index) => {
                                return (
                                    <Fragment key={index}>
                                        <div className="seg">
                                            <div className="seg-flight-time first-row">
                                                {value.depTime !== undefined && value.depTime}
                                            </div>
                                            <div className="seg-dots">
                                                <span className="dot"></span>
                                                <span className="dot"></span>
                                            </div>
                                            <div className="seg-airport first-row">
                                                {value.depAirportDescription !== undefined &&
                                                    value.depAirportDescription + ' '}
                                                {value.depAirportCode !== undefined &&
                                                    ' (' + value.depAirportCode + ') '}
                                            </div>
                                            <div className="seg-info">
                                                <div className="flight-duration">
                                                    {value.duration !== undefined && getHoursAndMinutes(value.duration)}
                                                </div>
                                                {value.airline !== undefined && value.airline}
                                                {value.carrier !== undefined && ' (' + value.carrier}
                                                {value.flightNumber !== undefined && value.flightNumber + ')'}
                                            </div>
                                            <div className="seg-flight-time third-row">
                                                {value.arrTime !== undefined && value.arrTime}
                                            </div>
                                            <div className="seg-airport third-row">
                                                {value.arrAirportDescription !== undefined &&
                                                    value.arrAirportDescription + ' '}
                                                {value.arrAirportCode !== undefined &&
                                                    ' (' + value.arrAirportCode + ') '}
                                            </div>
                                        </div>
                                        {index < f.outbound.length - 1 && (
                                            <div className="transit-time">
                                                <div className="dashed-line"></div>
                                                <div className="transit-info">
                                                    Umstieg
                                                    {value.stay !== undefined && ': ' + getHoursAndMinutes(value.stay)}
                                                </div>
                                            </div>
                                        )}
                                    </Fragment>
                                );
                            })}
                        </div>
                    </div>
                )}

                {f.inbound !== undefined && (
                    <div className="inbound detail-item">
                        <i className="material-symbols-outlined flight-icon">flight</i>
                        <div>
                            <h4>
                                Rückflug: {getShortWeekday(f.inbound[0].depDate)}., {f.inbound[0].depDate} &middot;{' '}
                                {getFlightStops(f, 'inbound')}
                            </h4>

                            {f.inbound.map((value, index) => {
                                return (
                                    <Fragment key={index}>
                                        <div className="seg">
                                            <div className="seg-flight-time first-row">
                                                {value.depTime !== undefined && value.depTime}
                                            </div>
                                            <div className="seg-dots">
                                                <span className="dot"></span>
                                                <span className="dot"></span>
                                            </div>
                                            <div className="seg-airport first-row">
                                                {value.depAirportDescription !== undefined &&
                                                    value.depAirportDescription + ' '}
                                                {value.depAirportCode !== undefined &&
                                                    ' (' + value.depAirportCode + ') '}
                                            </div>
                                            <div className="seg-info">
                                                <div className="flight-duration">
                                                    {value.duration !== undefined && getHoursAndMinutes(value.duration)}
                                                </div>
                                                {value.airline !== undefined && value.airline}
                                                {value.carrier !== undefined && ' (' + value.carrier}
                                                {value.flightNumber !== undefined && value.flightNumber + ')'}
                                            </div>
                                            <div className="seg-flight-time third-row">
                                                {value.arrTime !== undefined && value.arrTime}
                                            </div>
                                            <div className="seg-airport third-row">
                                                {value.arrAirportDescription !== undefined &&
                                                    value.arrAirportDescription + ' '}
                                                {value.arrAirportCode !== undefined &&
                                                    ' (' + value.arrAirportCode + ') '}
                                            </div>
                                        </div>
                                        {index < f.inbound.length - 1 && (
                                            <div className="transit-time">
                                                <div className="dashed-line"></div>
                                                <div className="transit-info">
                                                    Umstieg
                                                    {value.stay !== undefined && ': ' + getHoursAndMinutes(value.stay)}
                                                </div>
                                            </div>
                                        )}
                                    </Fragment>
                                );
                            })}
                        </div>
                    </div>
                )}
                {(f.outbound !== undefined || f.inbound !== undefined) && (
                    <div className="flight-disclaimer">Bei allen Uhrzeiten handelt es sich um Ortsangaben.</div>
                )}
            </>
        );
    }

    excursionDetails() {
        const { data } = this.state.bookingData;

        if (
            data?.frontendParams?.excursions &&
            data.allowExtraServicesExcursion &&
            window.$content.extras.excursion?.active
        ) {
            const { excursions } = data.frontendParams;

            const activeExcursions = _.filter(excursions, function (o) {
                return o.state === 'OK' || o.state === 'MO';
            });

            const inactiveExcursions = _.filter(excursions, function (o) {
                return o.state === 'XX' && o.state !== 'MO';
            });

            return (
                <div className="item">
                    <i className="material-symbols-outlined">attractions</i>
                    <div>
                        {data.frontendParams.excursions.length > 0 ? (
                            <div>
                                {activeExcursions.length >= 1 && (
                                    <div className="active">
                                        <>{`${activeExcursions.length} ${
                                            activeExcursions.length > 1 ? 'Ausflüge' : 'Ausflug'
                                        } gebucht`}</>
                                    </div>
                                )}

                                {inactiveExcursions.length >= 1 && (
                                    <div className="inactive">
                                        <>
                                            {`${inactiveExcursions.length} ${
                                                inactiveExcursions.length > 1 ? 'Ausflüge' : 'Ausflug'
                                            } gebucht`}
                                            <span className="chip storno"></span>
                                        </>
                                    </div>
                                )}

                                <div className="user-interaction">
                                    <div
                                        className="button-element button-ghost"
                                        onClick={() => {
                                            this.toggleModal('excursionDetails');
                                        }}>
                                        Ausflugdetails anzeigen
                                    </div>

                                    {this.state.excursionDetailsModal && (
                                        <OverlayModal
                                            name="excursion-details"
                                            displayName="Ausflugdetails"
                                            scrollable={true}
                                            toggleModal={() => {
                                                this.toggleModal('excursionDetails');
                                            }}>
                                            {excursions !== undefined &&
                                                excursions.length > 0 &&
                                                excursions.map((value, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            {index > 0 && <hr />}
                                                            <ExcursionItem item={value} />
                                                        </Fragment>
                                                    );
                                                })}
                                        </OverlayModal>
                                    )}

                                    {this.props.bookingState === 'OK' && (
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            className="button-element button-ghost"
                                            href="#/ausfluege">
                                            Weitere Ausflüge buchen
                                        </a>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div>
                                Ohne Ausflüge
                                {this.props.bookingState === 'OK' && (
                                    <div>
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            className="button-element button-ghost"
                                            href="#/ausfluege">
                                            Ausflüge buchen
                                        </a>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            );
        }
    }

    seatReservationDetails() {
        const { data } = this.state.bookingData;

        const getSeat = (f, t) => {
            const { bookedSeats } = data.serviceInformation;
            let returnValue = '--';

            Object.keys(bookedSeats).forEach((value) => {
                if (
                    bookedSeats[value].arrivalAirport === f.arrAirportCode &&
                    bookedSeats[value].departureAirport === f.depAirportCode &&
                    t.foreName === bookedSeats[value].participant.firstName &&
                    t.surName === bookedSeats[value].participant.lastName &&
                    t.birthDate === bookedSeats[value].participant.birthDate &&
                    (bookedSeats[value].state === 'MO' ||
                        bookedSeats[value].state === 'RQ' ||
                        bookedSeats[value].state === 'OK')
                ) {
                    returnValue = bookedSeats[value].seat;
                }
            });

            return returnValue;
        };

        if (
            window.$content.extras.seatReservation.active === true &&
            data !== undefined &&
            data.allowSeatReservations === true &&
            data?.serviceInformation.flight !== undefined
        ) {
            let hasSeatReservation = false;
            const { flightDetails, travellers } = data.frontendParams;

            if (data?.serviceInformation.bookedSeats !== undefined) {
                Object.keys(data.serviceInformation.bookedSeats).forEach((value) => {
                    let state = data.serviceInformation.bookedSeats[value].state;
                    if (state === 'OK' || state === 'MO' || state === 'RQ') {
                        hasSeatReservation = true;
                    }
                });
            }

            return (
                <>
                    <div className="item">
                        <i className="material-symbols-outlined">airline_seat_recline_normal</i>
                        <div>
                            {hasSeatReservation ? (
                                <div>
                                    Mit Sitzplatzreservierung (Flug)
                                    <div>
                                        <div
                                            className="button-element button-ghost"
                                            onClick={() => {
                                                this.toggleModal('seatReservation');
                                            }}>
                                            Sitzplätze anzeigen
                                        </div>
                                    </div>
                                    {this.state.seatReservationModal && (
                                        <OverlayModal
                                            name="seatreservation-details"
                                            displayName="Sitzplatzreservierung"
                                            scrollable={false}
                                            toggleModal={() => {
                                                this.toggleModal('seatReservation');
                                            }}>
                                            {data?.allowSeatReservationOutbound && (
                                                <>
                                                    <div className="left outbound">
                                                        {flightDetails.outbound.map((value, index) => {
                                                            return (
                                                                <div
                                                                    className="detail-item leg"
                                                                    key={'outbound-' + index}>
                                                                    <div>
                                                                        <i className="material-symbols-outlined flight-icon">
                                                                            flight
                                                                        </i>
                                                                        <i className="material-symbols-outlined airline-seat">
                                                                            airline_seat_recline_normal
                                                                        </i>
                                                                    </div>
                                                                    <div className="cnt">
                                                                        <h4>
                                                                            Hinflug: {getShortWeekday(value.depDate)}.,{' '}
                                                                            {value.depDate} &middot;{' '}
                                                                            {value.depAirportCode} -{' '}
                                                                            {value.arrAirportCode}
                                                                        </h4>

                                                                        {travellers !== undefined &&
                                                                            travellers.map((t, index) => {
                                                                                return (
                                                                                    <div
                                                                                        className="traveller-seats"
                                                                                        key={`outbound-traveller-${value.flightNumber}-${index}`}>
                                                                                        <div className="traveller">
                                                                                            {t.foreName} {t.surName}
                                                                                        </div>
                                                                                        <div className="seat">
                                                                                            {getSeat(value, t)}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    {window.$browserInfo.device === 'mobile' && <hr />}
                                                </>
                                            )}
                                            {data?.allowSeatReservationInbound && (
                                                <div className="right inbound">
                                                    {flightDetails.inbound.map((value, index) => {
                                                        return (
                                                            <div className="detail-item leg" key={'inbound-' + index}>
                                                                <div>
                                                                    <i className="material-symbols-outlined flight-icon">
                                                                        flight
                                                                    </i>
                                                                    <i className="material-symbols-outlined airline-seat">
                                                                        airline_seat_recline_normal
                                                                    </i>
                                                                </div>
                                                                <div className="cnt">
                                                                    <h4>
                                                                        Rückflug: {getShortWeekday(value.depDate)}.,{' '}
                                                                        {value.depDate} &middot; {value.depAirportCode}{' '}
                                                                        - {value.arrAirportCode}
                                                                    </h4>

                                                                    {travellers.map((t, index) => {
                                                                        return (
                                                                            <div
                                                                                className="traveller-seats"
                                                                                key={`inbound-traveller-${value.flightNumber}-${index}`}>
                                                                                <div className="traveller">
                                                                                    {t.foreName} {t.surName}
                                                                                </div>
                                                                                <div className="seat">
                                                                                    {getSeat(value, t)}
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}

                                            {!data.isAllPossibleSeatsBooked && (
                                                <Link
                                                    rel="noopener noreferrer"
                                                    to={'/sitzplatzreservierung'}
                                                    target="_blank"
                                                    className="button-element button-ghost book-seats">
                                                    Weitere Sitzplätze buchen
                                                </Link>
                                            )}
                                        </OverlayModal>
                                    )}
                                </div>
                            ) : (
                                <div>
                                    Ohne Sitzplatzreservierung (Flug)
                                    <div>
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            className="button-element button-ghost"
                                            href="#/sitzplatzreservierung">
                                            Sitzplatz hinzufügen
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            );
        }
    }

    travellerDetails() {
        return (
            <>
                {this.state.bookingData.data.frontendParams?.travellers && (
                    <div className="item">
                        <i className="material-symbols-outlined">how_to_reg</i>
                        <div>
                            <div>Reisende</div>
                            <div
                                className="button-element button-ghost"
                                onClick={() => {
                                    this.toggleModal('travellerDetails');
                                }}>
                                Reisende anzeigen
                            </div>
                        </div>
                    </div>
                )}

                {this.state.travellerDetailsModal && (
                    <OverlayModal
                        name="traveller-details"
                        displayName="Reisende"
                        scrollable={false}
                        toggleModal={() => {
                            this.toggleModal('travellerDetails');
                        }}>
                        <div className="travellers detail-item">
                            <i className="material-symbols-outlined">how_to_reg</i>
                            <div className="cnt">
                                <h4>Reisende</h4>
                                {getTravellers(this.state.bookingData.data.frontendParams)}
                            </div>
                        </div>
                    </OverlayModal>
                )}
            </>
        );
    }

    getInsuranceData() {
        let insuranceData = undefined;

        if (this.state.bookingData !== null) {
            if (this.state.bookingData.data.serviceInformation.insurance !== undefined) {
                insuranceData = {
                    description: this.state.bookingData.data.serviceInformation.insurance.description,
                };
            }

            if (this.state.bookingData.bookedService !== undefined) {
                if (this.state.bookingData.bookedService.insurance !== undefined) {
                    insuranceData = {
                        description: this.state.bookingData.bookedService.insurance.data.serviceDescription,
                    };
                }
            }

            this.setState({
                insuranceData: insuranceData,
            });
        }
    }

    // Todo: brauchen wir das noch oder kann das weg?
    getTransferData() {
        let transferData = undefined;
        let getTransferMapper = window.$content.mappingTransfer;

        let tariffCode = null;

        if (this.state.bookingData !== null) {
            if (this.state.bookingData.data.serviceInformation.transfer !== undefined) {
                tariffCode = this.state.bookingData.data.serviceInformation.transfer.description.toLowerCase();
            }

            if (this.state.bookingData.bookedService !== undefined) {
                if (this.state.bookingData.bookedService.transfer !== undefined) {
                    if (this.state.bookingData.bookedService.transfer.data.tariffCode !== undefined) {
                        tariffCode = this.state.bookingData.bookedService.transfer.data.tariffCode.toLowerCase();
                    }
                }
            }

            if (getTransferMapper[tariffCode] !== undefined && getTransferMapper[tariffCode].iLayer !== undefined) {
                transferData = {
                    description: getTransferMapper[tariffCode].iLayer,
                };
            }

            this.setState({
                transferData: transferData,
            });
        }
    }

    render() {
        const { travelType, frontendParams, allowExtraServices } = this.state.bookingData.data;

        return (
            <>
                {frontendParams && (
                    <div className="page-content">
                        {/* HOTEL */}
                        {frontendParams.hotelDetails !== undefined && (
                            <>
                                <div className="section hotel">{this.hotelDetails(frontendParams.hotelDetails)}</div>
                            </>
                        )}

                        {/* CRUISE */}
                        {this.context?.travelType === 'cruise' && frontendParams.cruise !== null && (
                            <>
                                <div className="section cruise">{this.cruiseDetails(frontendParams.cruise)}</div>
                            </>
                        )}

                        {/* Travellers */}
                        {this.travellerDetails() !== undefined && (
                            <>
                                <div className="section traveller-details">{this.travellerDetails()}</div>
                            </>
                        )}

                        {/* Flight */}
                        {frontendParams.flightDetails !== undefined && (
                            <>
                                <hr />
                                <div className="section flight">
                                    <h4 className="subline">Flüge</h4>
                                    {this.flightDetails(frontendParams.flightDetails)}
                                </div>
                            </>
                        )}

                        {/* Additional services */}
                        {((this.props.bookingState === 'OK' && allowExtraServices) ||
                            this.seatReservationDetails() ||
                            this.excursionDetails()) && (
                            <>
                                <hr />
                                <h4 className="subline">Zusatzleistungen</h4>

                                {travelType === 'package' && (
                                    <>
                                        {/* TRANSFER & RAIL AND FLY */}
                                        {this.props.bookingState === 'OK' && (
                                            <>
                                                <div className="section transfer">
                                                    {this.transferDetails(frontendParams.transferDetails)}
                                                </div>
                                            </>
                                        )}

                                        {/* SeatReservation */}
                                        {this.seatReservationDetails() !== undefined && (
                                            <div className="section seatReservation">
                                                {this.seatReservationDetails()}
                                            </div>
                                        )}
                                    </>
                                )}

                                {/* Excursion */}
                                {this.excursionDetails() !== undefined && (
                                    <>
                                        {travelType === 'hotel' && <hr />}
                                        <div className="section excursion">{this.excursionDetails()}</div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                )}
            </>
        );
    }
}

export default memo(BookingDetails);
